import { t } from 'ttag'

import budgetIllustration from '@h2/assets/svg/illustrations/activities/budget.svg'
import collegePreferencesIllustration from '@h2/assets/svg/illustrations/activities/collegePreferences.svg'
import interestProfilerIllustration from '@h2/assets/svg/illustrations/activities/interestProfiler.svg'
import workKeysIllustration from '@h2/assets/svg/illustrations/activities/workKeys.svg'
import skillsProfilerIllustration from '@h2/assets/svg/illustrations/activities/skillsProfiler.svg'
import quickAssessmentIllustration from '@h2/assets/svg/illustrations/activities/quickAssessment.svg'
import workImportanceIllustration from '@h2/assets/svg/illustrations/activities/workImportanceProfiler.svg'
import utlIllustration from '@h2/assets/svg/illustrations/activities/upTheLadder.svg'
import wblIllustration from '@h2/assets/svg/illustrations/activities/exploreWorkBasedLearning.svg'
import occupationsIllustration from '@h2/assets/svg/illustrations/activities/exploreOccupations.svg'
import collegesIllustration from '@h2/assets/svg/illustrations/activities/exploreColleges.svg'
import pathwaysIllustration from '@h2/assets/svg/illustrations/activities/explorePathways.svg'
import certificationsIllustration from '@h2/assets/svg/illustrations/activities/exploreCertificates.svg'
import majorsIllustration from '@h2/assets/svg/illustrations/activities/exploreMajors.svg'
import resumeBuilderIllustration from '@h2/assets/svg/illustrations/activities/resumeBuilder.svg'
import listBuilderIllustration from '@h2/assets/svg/illustrations/activities/listBuilder.svg'
import letterBuilderIllustration from '@h2/assets/svg/illustrations/activities/letterBuilder.svg'
import videoLibraryIllustration from '@h2/assets/svg/illustrations/activities/videoLibrary.svg'
import jobSearchIllustration from '@h2/assets/svg/illustrations/activities/jobSearch.svg'
import apprenticeshipSearchIllustration from '@h2/assets/svg/illustrations/activities/apprenticeshipSearch.svg'
import chooseIndustryIllustration from '@h2/assets/svg/illustrations/activities/chooseIndustry.svg'
import financialAidIllustration from '@h2/assets/svg/illustrations/activities/financialAid.svg'

export const listingData = (budgetTitle, tenantId) => ({
  budget: {
    url: '/budget/',
    useSitemap: true,
    title: budgetTitle,
    image: budgetIllustration,
    description: t`How much money will you need to support your lifestyle, and which occupations will enable you lead the life you want? Developing a budget can help you explore these options.`
  },
  interestprofiler: {
    url: '/ip',
    useSitemap: true,
    title: t`Interest Profiler`,
    image: interestProfilerIllustration,
    description: t`Discover what your interests are, and how they relate to the world of work. The Interest Profiler helps you decide what kinds of occupations and jobs you might want to explore based on your interests.`
  },
  collegepref: {
    url: '/colleges/preferences',
    useSitemap: true,
    title: t`My College Preferences`,
    image: collegePreferencesIllustration,
    description: t`Do you want to spend time in the city or the country? Do you have a preference for different parts of the country? Let the system know so it can help you find your most compatible schools.`
  },
  quickassessment: {
    url: '/quick',
    useSitemap: true,
    title: t`Quick Assessment`,
    image: quickAssessmentIllustration,
    description: t`Explore jobs that best match your personality. Are you realistic, investigative, artistic, social, enterprising, or conventional? Find out with this quick assessment`
  },
  workimportanceprofiler: {
    url: '/wip/',
    useSitemap: false,
    title: t`Work Importance Profiler`,
    image: workImportanceIllustration,
    description: t`What's important to you in a job? Discover how much you value achievement, independence, recognition, relationships, support, and working conditions in a job. Get a list of jobs that reflect your values.`
  },
  skillsprofiler: {
    url: '/skills/',
    useSitemap: false,
    title: t`Skills Profiler`,
    image: skillsProfilerIllustration,
    description: t`What skills have you acquired through your jobs and other activities? The Skills Profiler can help you explore occupations that require your skillset.`
  },
  workkeys: {
    url: '/workkeys/',
    useSitemap: false,
    title: t`Work Keys`,
    image: workKeysIllustration,
    description: t`Keep track of your scores from your Work Keys assessment and see jobs that match your results.`
  },
  utl: {
    url: '/ladder',
    useSitemap: true,
    title: t`Up The Ladder`,
    image: utlIllustration,
    description: t`Designed for younger learners, Up the Ladder exposes you to Career Information in a  game format.`
  },
  explorePathways: {
    url: '/clusters',
    useSitemap: true,
    title: tenantId !== 'california' ? t`Explore Pathways` : t`Explore Industry Sectors`,
    image: pathwaysIllustration,
    description: t`Find out more about your local options by exploring broad clusters and pathways that help organized the options you will have.`
  },
  exploreColleges: {
    url: '/colleges/location',
    useSitemap: true,
    title: t`Explore Colleges`,
    image: collegesIllustration,
    description: t`Explore educational institutions within the United States to help you find the options that might suit you.`
  },
  exploreOccupations: {
    url: '/occupations/list',
    useSitemap: true,
    title: t`Explore Occupations`,
    image: occupationsIllustration,
    description: t`Explore all the occupations in the system, whether you know the occupation you wish to pursue or you want to compare a few to see which might a good fit.`
  },
  exploreMajors: {
    url: '/majors/choosing',
    useSitemap: true,
    title: t`Explore Fields of Study`,
    image: majorsIllustration,
    description: t`Look through the various programs of study in the system to narrow down what you might major in.`
  },
  majorPathways: {
    url: '/majors/clusters',
    useSitemap: true,
    title: t`Type of Field`,
    image: pathwaysIllustration,
    description: t`Find out more about programs of study by exploring broad clusters and pathways that help organize the options you will have.`
  },
  exploreCertifications: {
    url: '/education/list?types=certifications',
    useSitemap: false,
    title: t`Explore Certifications`,
    image: certificationsIllustration,
    description: t`Learn about various credentials that you might be able to obtain. Credentials can be a great way to enhance your employability by verifying your skillset.`
  },
  exploreWbl: {
    url: '/opportunities',
    useSitemap: true,
    title: t`Explore Work-Based Learning`,
    image: wblIllustration,
    description: t`Explore opportunities in your area that you can participate in while in school.`
  },
  exploreOldWbl: {
    url: '/education_training/list',
    useSitemap: false,
    title: t`Explore Work-Based Learning`,
    image: wblIllustration,
    description: t`Explore opportunities in your area that you can participate in while in school.`
  },
  financialAid: {
    url: '/colleges/financialaid',
    useSitemap: true,
    title: t`Financial Aid`,
    image: financialAidIllustration,
    description:
      'Explore some sources for financial aid and find out more about paying for college.'
  },
  costOfCollege: {
    url: '/colleges/costbenefit',
    useSitemap: true,
    title: t`The Cost of College`,
    image: collegesIllustration,
    description:
      'What will college cost and how much will you likely earn afterward. Use this tool to help balance those two parts of the equation.'
  },
  jobSearch: {
    url: '/jobs',
    title: t`Job Search`,
    useSitemap: true,
    image: jobSearchIllustration,
    description:
      'Find current job openings across the United States and apply for them online.'
  },
  apprenticeshipSearch: {
    url: '/jobs',
    title: t`Find Apprenticeship`,
    useSitemap: true,
    image: apprenticeshipSearchIllustration,
    description:
      'Explore available apprenticeship opportunities near you, as well as anywhere else in the United States.'
  },
  jobtoolBuilder: {
    url: '/jobtools',
    useSitemap: true,
    title: t`Job Application Tools`,
    image: occupationsIllustration,
    description: t`When you are ready to apply for a job there are a few documents you'll want to prepare. Use this tool to help create them.`
  },
  resumeBuilder: {
    url: '/jobtools/resume',
    useSitemap: true,
    title: t`Resume Builder`,
    image: resumeBuilderIllustration,
    description: t`Before you can apply for a job, you'll likely need a resume. Use this tool to help you create one.`
  },
  letterBuilder: {
    url: '/jobtools/coverletter',
    useSitemap: true,
    title: t`Letter Builder`,
    image: letterBuilderIllustration,
    description: t`Letters are an important way to communicate with employers, from a cover letter that you send along with your resume, to a thank you letter after an interview, this tool can help.`
  },
  listBuilder: {
    url: '/jobtools/references',
    useSitemap: true,
    title: t`Reference List Builder`,
    image: listBuilderIllustration,
    description: t`When you apply for a job, you'll often be asked for a list of references. Use this tool to help you create and organize your listing.`
  },
  mySummaryReport: {
    url: '/rep/portfolio',
    useSitemap: true,
    title: t`My Summary Report`,
    description: t`Your summary report helps track all the exploration you have done throughout the system in a single document.`
  },
  videoLibrary: {
    url: '/videos',
    useSitemap: true,
    title: t`Video Library`,
    image: videoLibraryIllustration,
    description: t`Explore our video library, featuring several hundred videos about the occupations in our system.`
  },
  choosingIndustry: {
    url: '/industry/choosing',
    useSitemap: true,
    title: t`Choosing an Industry`,
    image: chooseIndustryIllustration,
    description: t`Industries are groupings of businesses that make similar products or provide similar services. Use this tool to explore industries from several perspectives.`
  }
})
